import React from 'react';
import { Fab, Zoom, useScrollTrigger, Grid} from '@mui/material';
import { HiOutlineArrowNarrowUp, } from "react-icons/hi";

const ContentProject = (props) => {
    return (
        <React.Fragment>
            <Grid item container xs={12} md={12} spacing={2} justifyContent={"flex-start"}  
                style={{
                    padding: '1%',
                    background: 'white',
                    position: 'relative',
                    backgroundSize: 'cover',
                    lineHeight: '1rem',
                    borderRadius: '20px',
                    backgroundRepeat: 'no-repeat',
                    boxShadow: 'rgb(199 199 199 / 83%) 0px 0px 5px',
                }}
            >
                {props.children}
            </Grid>    
            <ScrollToTop>
                <Fab
                    color="error"
                    size="large"
                    sx={{
                        flexDirection: "column",
                        borderRadius: "16px",
                        width: "35px",
                        height: "70px",
                        textAlign: "center",
                        lineHeight: "1",
                        fontSize: "13px",
                        backgroundColor: "#ff0000"
                    }}
                >
                    <HiOutlineArrowNarrowUp size="25" />
                    <span style={{ marginTop: '8px', textTransform: 'uppercase', color: 'white' }}>
                        UP
                    </span>
                </Fab>
            </ScrollToTop>
        </React.Fragment>
    )
}
export default ContentProject;

const ScrollToTop = (props) => {
    const { children } = props;
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 300,
    });

    const handleClick = (event) => {
        window.scrollTo({ top: 0, behavior: `smooth` })
    };

    return (
        <Zoom in={trigger}>
            <div
                onClick={handleClick}
                role="presentation"
                style={{
                    position: "fixed",
                    bottom: "12px",
                    right: "15px",
                    width: "46.7px",
                    height: "87.5px",
                }}
            >
                {children}
            </div>
        </Zoom>
    );
};
